import {RETRIEVE_NOTIFICATION_GROUP_LIST} from '@/api'
import {CREATE_NOTIFICATION_GROUP} from '@/api'
import {GET_NOTIFICATION_GROUP_INFO} from '@/api'
import {UPDATE_ADMIN_NOTIFICATION_GROUP} from '@/api'
import {DELETE_ADMIN_NOTIFICATION_GROUP} from '@/api'

export default {
  retrieveNotificationGroupList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_notification_group_list.length) {

        commit('retrieveNotificationGroupList', {notificationGroupList: response.data.data.admin_notification_group_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_NOTIFICATION_GROUP_LIST({}, successCallback, errorCallback)
  },

  createNotificationGroup({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_notification_group_info) {
        // commit('addClassToList', {classList: response.data.data.class_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_NOTIFICATION_GROUP({data: payload.data}, successCallback, errorCallback)
  },

  updateNotificationGroup({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_notification_group_info) {
        commit('getNotificationGroupInfo', {notificationGroupInfo: response.data.data.admin_notification_group_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    UPDATE_ADMIN_NOTIFICATION_GROUP({data: payload}, successCallback, errorCallback)
  },

  getNotificationGroupInfo({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.admin_notification_group_info) {
        commit('getNotificationGroupInfo', {notificationGroupInfo: response.data.data.admin_notification_group_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    GET_NOTIFICATION_GROUP_INFO({payload}, successCallback, errorCallback)
  },

  deleteAdminNotificationGroup({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      commit('deleteNotificationGroup', {notificationGroupInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_ADMIN_NOTIFICATION_GROUP({payload}, successCallback, errorCallback)
  }
};
